import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/park/handover/handover/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/park/handover/handover/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/park/handover/handover/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/park/handover/handover/save', params,options)

export const update = (params, options) =>
request.post('/api/park/handover/handover/update', params,options)
